import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import BillSearch from "../components/BillSearch/BillSearch";
import BillTable from "../components/BillTable/BillTable";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { fetchBills, billsSelector } from "../_redux/billsSlice";
import { RootState } from "../../../../redux/rootReducer";
import BillPopup from "../components/BillPopup";
import { useFlags } from "../../../../config/featureFlags";

function BillsListPage() {
  const { DISPLAY_LIKUMI_CONTENT } = useFlags();
  const dispatch = useDispatch();
  const { fetchingBillsError } = useSelector(billsSelector);
  const { currentPage } = useSelector(billsSelector);
  const { user } = useSelector(
    ({ auth }: RootState) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchBills({ tag: "", pageNumber: currentPage }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetchingBillsError) return <div>{fetchingBillsError.message}</div>;

  return (
    <>
      <Row>
        <Col sm={12}>
          <div className="mb-5">
            <BillSearch />
          </div>
          <BillTable />

          {DISPLAY_LIKUMI_CONTENT && <BillPopup />}
        </Col>
      </Row>
    </>
  );
}

export default BillsListPage;
